import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import blogs from "./blogdata";
import {
  ArrowLeft,
  ArrowRight,
  CircleUserRound,
  CalendarDays,
  ChevronDown,
} from "lucide-react";
import { useLenis } from "lenis/react";

const BlogDetail = () => {
  const params = useParams();
  const [blogData, setBlogData] = useState();
  const [filterBlogs, setFilterBlogs] = useState([]);
  const slug = params.id;
  useEffect(() => {
    try {
      const filteredData = blogs.filter((f) => f.link !== slug).slice(0, 4);
      const data = blogs.find((u) => u.link === slug);
      setBlogData(data);
      setFilterBlogs(filteredData);
    } catch (error) {
      console.log(error);
    }
  }, [slug]);
  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
const lenis = useLenis()
  useEffect(() => {
     if (lenis) {
       lenis.scrollTo(0, {
         duration: 1.2,
       });
     }
     
   }, [lenis]);
  return (
    <div className=" xl:py-40 lg:py-32 md:py-28 py-20 relative ">
      <div className="xl:w-[1280px] xl:px-10 px-0 2xl:px-0 w-11/12 mx-auto xl:pt-8 lg:pt-16 md:pt-20 pt-16  relative flex-col z-10">
        <Link
          to="/blogs"
          className=" flex  py-3 w-44  mb-5 text-[#B87333]  text-base font-semibold border border-matcha   flex-row items-center justify-center gap-4 rounded-full  hover:text-white hover:bg-matcha duration-200 transition"
        >
          <ArrowLeft /> Back to blogs
        </Link>
        <div  className="grid grid-cols-12 gap-5 ">
          <div data-aos="fade-up" className="lg:col-span-8 md:col-span-7 col-span-12  space-y-5">
            <h1 className="lg:text-4xl md:text-3xl text-xl font-bold mt-2 text-matcha leading-tight">
              {blogData?.mainTitle}
            </h1>
            <figure className="rounded-xl overflow-hidden">
              <img
                loading="lazy"
                src={blogData?.image}
                alt={blogData?.mainTitle}
              />
            </figure>
            <div className="flex flex-row gap-4 items-center px-1">
              <p className="flex flex-row items-center gap-2 border border-match px-2 py-1 rounded-full border-matcha text-base text-matcha font-semibold">
                <CircleUserRound className="text-matcha" size={20} /> Doctor
              </p>
              <p className="flex flex-row items-center gap-2 border border-match px-2 py-1 rounded-full border-matcha text-base text-matcha font-semibold">
                <CalendarDays className="text-matcha" size={18} />{" "}
                {blogData?.date}
              </p>
            </div>
            <p className="text-base text-matcha font-normal pb-1">
              {blogData?.introduction}
            </p>
            {blogData?.sections.map((item, index) => (
              <div key={item.heading}>
                <h2 className=" mb-1.5 line-clamp-2 md:text-xl text-lg font-bold text-matcha">
                  {item.heading}
                </h2>
                <p className="text-base text-matcah font-normal pb-1">
                  {item?.paragraph}
                </p>
              </div>
            ))}
            <p className="text-base text-matcha font-normal pb-1">
              {blogData?.conclusion}
            </p>
            <h2 className=" mb-1.5 line-clamp-2 md:text-xl text-lg font-bold text-matcha">
              Frequently asked questions
            </h2>
            <div className="flex flex-col gap-6">
              {blogData?.faqs?.map((faq, index) => {
                const realIndex = index * 2;
                const isOpen = openIndex === realIndex;
                return (
                  <div
                    key={faq.question}
                    className="rounded-lg  bg-match backdrop-blur-md overflow-hidden bg-matcha transition-all duration-200 hover:shadow-xl"
                  >
                    <button
                      onClick={() => toggleFAQ(realIndex)}
                      className=" w-full flex items-center justify-between  text-left p-3 md:p-4 "
                    >
                      <h3 className="md:text-lg text-base font-semibold text-white pr-4">
                        {faq.question}
                      </h3>

                      <ChevronDown
                        className={`min-w-5 min-h-5 text-[#1d9e75] transition-transform duration-500 ${isOpen ? "rotate-180" : ""}`}
                      />
                    </button>
                    <div
                      className={`  grid transition-all duration-300 ease-in-out ${
                        isOpen
                          ? "grid-rows-[1fr] opacity-100"
                          : "grid-rows-[0fr] opacity-0"
                      } `}
                    >
                      <div className="overflow-hidden">
                        <p className="md:px-6 md:pb-6 px-3 pb-3 text-white leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div data-aos="fade-up" className="lg:col-span-4 md:col-span-5 col-span-12">
            <div className="w-full lg:sticky lg:top-10  flex flex-col gap-5 rounded-lg ">
              {filterBlogs.map((blog, index) => (
                <div
                  className="group relative flex flex-col p-2 rounded-lg bg-[#E8EDF2] overflow-hidden shadow-md   "
                  key={index + blog.link}
                >
                  <div className="flex flex-col justify-between flex-1 sm:p-2 p-1">
                    <div>
                      <h3 className=" mb-1.5 line-clamp-2 md:text-xl text-lg font-bold text-matcha">
                        {blog.title}
                      </h3>
                      <div className=" text-sm mb-1.5 py-1">{blog.date}</div>
                    </div>
                    <Link
                      to={`/blogs/${blog.link}`}
                      className="bg-matcha py-2 w-36 text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-2 rounded-lg hover:bg-transparent hover:text-matcha duration-200 transition"
                    >
                      Read More <ArrowRight strokeWidth={1} />
                    </Link>
                  </div>
                </div>
              ))}
              <Link
                to="/contact-me"
                className="bg-matcha py-3 text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-4 rounded-xl hover:bg-transparent hover:text-matcha duration-200 transition"
              >
                Book An Appointment <ArrowRight strokeWidth={1} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
